import { db } from "../FirebaseConfig";
import { collection, addDoc, getDocs, doc, getDoc, updateDoc, deleteDoc } from "firebase/firestore";

const infoCollectionRef = collection(db, "project");

class InfoDataService {
  addInfo = (newInfo) => {
    return addDoc(infoCollectionRef, newInfo);
  };

  updateInfo = (id, updatedInfo) => {
    const infoDoc = doc(db, "info", id);
    return updateDoc(infoDoc, updatedInfo);
  };

  getAllInfo = async () => {
    return getDocs(infoCollectionRef);
  };

  getInfoById = async (id) => {
    const infoDoc = await getDoc(doc(db, "info", id));
    if (infoDoc.exists()) {
      return { id: infoDoc.id, ...infoDoc.data() };
    } else {
      return null;
    }
  };

  deleteInfo = async (id) => {
    await deleteDoc(doc(db, "info", id));
  };
}

export default new InfoDataService();
